import { useState, useEffect, useMemo } from 'react';
import { useMutation } from '@apollo/client';
import SelectInput from '../inputs/SelectInput';
import { UPDATE_USER_RATECARD_MUTATION } from '../../queries/ratecards';

export function RateCardSelector({ currentValue, userId, rateCardOptions }) {
  // Initialize with the current rateCard id if it exists
  const initialValue = currentValue?.id || '';
  const [selected, setSelected] = useState(initialValue);

  const [updateUserRatecard] = useMutation(UPDATE_USER_RATECARD_MUTATION);

  // Update selected value when currentValue changes
  useEffect(() => {
    if (currentValue?.id) {
      setSelected(currentValue.id);
    }
  }, [currentValue]);

  // Convert rateCardOptions to SelectInput format
  const selectOptions = useMemo(() => {
    const options = rateCardOptions.map((rc) => ({
      name: rc.name,
      value: rc.id,
    }));
    return options;
  }, [rateCardOptions]);

  const handleChange = async (newRateCardId: string) => {
    setSelected(newRateCardId);

    if (!newRateCardId) return; // Don't update if empty selection

    try {
      await updateUserRatecard({
        variables: {
          userId,
          rateCardId: newRateCardId,
        },
      });
    } catch (err) {
      console.error('Failed to update rate card:', err);
      alert('Update failed');
      // Revert the selection on error
      setSelected(initialValue);
    }
  };

  return (
    <SelectInput
      value={selected}
      onChange={handleChange}
      options={selectOptions}
      small={true}
      className="min-w-0"
      placeholder="Select a ratecard"
      emptyLabel="No ratecards"
    />
  );
}
